import * as z from 'zod/mini'
import { customerNoteField } from '../../schemas/common'
import { contactFields } from '../../schemas/contact'

/**
 * A member of the public signing up for an event (`entities/:entityId/events/:eventId/join`).
 *
 * Beyond the contact fields, the sign-up form makes the person confirm two consents:
 * - `termsAgreed` must be `true` - agreeing to the terms and conditions is mandatory to reserve.
 * - `marketingConsent` is optional - whether the premise may use their email for marketing.
 */
export const joinPublicEventBody = z.object({
  ...contactFields,
  /** "Poznámka pre prevádzku": stored only when the event allows it, dropped otherwise (a form loaded earlier). */
  note: z.optional(customerNoteField),
  termsAgreed: z.literal(true),
  marketingConsent: z.boolean(),
})
export type JoinPublicEventBody = z.infer<typeof joinPublicEventBody>
